import { render } from "./SelectorRutaEntregaComponent.vue?vue&type=template&id=722f2b80&scoped=true&class=margen"
import script from "./SelectorRutaEntregaComponent.vue?vue&type=script&lang=js"
export * from "./SelectorRutaEntregaComponent.vue?vue&type=script&lang=js"

import "./SelectorRutaEntregaComponent.vue?vue&type=style&index=0&id=722f2b80&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722f2b80"]])

export default __exports__